import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import _ from 'lodash'
import { FormattedMessage } from 'react-intl'

import config from '../../../../../../../../../config'

import { LOCALE_PREFIX, TABS, DEFAULT_TAB } from './constants'

import Tabs from './components/Tabs'

import NoData from '../../../../../../../components/Workspace/components/NoData'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'

import './style.scss'

@hocBlock(config.modules.portfolio.key)
export default class DetrimentalEvents extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        data: PropTypes.object,
        id: PropTypes.string.isRequired,
        level: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        saveCustomData: PropTypes.func.isRequired,
        token: PropTypes.string.isRequired,
    }

    static defaultProps = {
        customData: null,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.block !== nextProps.block) return true
        if (!_.isEqual(this.props.customData !== nextProps.customData)) return true
        if (!_.isEqual(this.props.data !== nextProps.data)) return true
        if (this.props.id !== nextProps.id) return true
        if (this.props.level !== nextProps.level) return true
        if (this.props.token !== nextProps.token) return true

        return false
    }

    onTabChanged = (type) => {
        const { saveCustomData } = this.props

        saveCustomData({ active: type })
    }

    render() {
        const { customData, data, block, id, level, token } = this.props

        const blockData = _.get(data, 'data', null)

        if (!blockData) return null

        const count = _.get(blockData, 'cnt', 0)
        if (count === 0) {
            return <NoData text={<FormattedMessage id={`${LOCALE_PREFIX}.noData`} />} />
        }

        const activeTab = _.get(customData, 'active', DEFAULT_TAB)

        return (
            <div className={cx('block-negative-events')}>
                <Tabs
                    tabs={TABS}
                    activeTab={activeTab}
                    onTabChanged={this.onTabChanged}
                    data={blockData}
                    id={id}
                    level={level}
                    block={block}
                    token={token}
                />
            </div>
        )
    }
}
